import { createContext } from "react";

export const BlockedFeatureContext = createContext<boolean>(false);
